import * as z from 'zod'

export const nonEmptyTrimmedStringSchema = z.string().trim().min(1)

export const idNoUnderscoreSchema = nonEmptyTrimmedStringSchema.refine(
  id => !id.includes('_'),
  `id cannot contain underscore`
)
